import { Typography } from "@mui/material";
import React from "react";

function Footer() {
  return (
    <div
      className="p-3 mt-5 text-center"
      style={{ backgroundColor: "#e0e0e0" }}
    >
      <Typography color="Gray" textAlign={"center"}>
        POLICY MEETING
      </Typography>
      <Typography variant="overline" textAlign={"center"}>
        &copy; {new Date().getFullYear()}
      </Typography>
    </div>
  );
}

export default Footer;
